import ReactController from '~/controllers/react_controller'
import AwsRdsCpuRightSizeRecommendationsCharts from '~/dashboard/aws_rds_cpu_right_size_recommendations_charts'

export default class AwsRdsCpuRightSizeRecommendationsController extends ReactController {
  static values = {
    organizationId: String,
    optimizationId: String,
    resourceId: String,
  }

  createComponent() {
    return (
      <AwsRdsCpuRightSizeRecommendationsCharts
        organizationId={this.organizationIdValue}
        optimizationId={this.optimizationIdValue}
        resourceId={this.resourceIdValue}
      />
    )
  }
}
